'use client';

import React, { Fragment } from 'react';
import { useAdsense } from '../../../hooks/useAdsense';
import { EndContentAd, InFeedAd, StickyMobileAd } from '../AdPlacement';

/**
 * Example implementation of a card list with optimized ad placements
 * This shows how to integrate the new ad system into existing components
 */
export default function CardListWithAds({ cards, CardComponent }) {
  const { showAds, getAdDensity, isMobile } = useAdsense();

  // Calculate ad frequency based on number of results
  const adDensity = getAdDensity(cards?.length || 0);

  return (
    <div className='w-full'>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-8 md:grid-cols-3 lg:grid-cols-4'>
        {cards?.map((card, index) => (
          <Fragment key={card.id}>
            {/* Insert ad after every N cards based on adDensity */}
            {index !== 0 && adDensity > 0 && index % adDensity === 0 && showAds && (
              <div className='w-full'>
                <InFeedAd height={250} />
              </div>
            )}

            {/* Render the card */}
            <div>
              <CardComponent card={card} />
            </div>
          </Fragment>
        ))}
      </div>

      {/* End of list ad */}
      {showAds && (
        <div className='mt-8 mb-4'>
          <EndContentAd />
        </div>
      )}

      {/* Mobile sticky ad - only shows on mobile */}
      {showAds && isMobile && <StickyMobileAd />}
    </div>
  );
}
